import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of } from 'rxjs';

import { AuthService } from 'src/app/services/auth.service';
import * as RecoveryActions from './recovery.action';

@Injectable()
export class RecoveryEffect {
  constructor(
    private actions$: Actions,

    private authService: AuthService,
    private store: Store
  ) {}

  loadUserByRecoveryEncryptedId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecoveryActions.GetUserByRecoveryEncryptedId),
      mergeMap((model) => {
        return this.authService.getUserByRecoveryEncryptedId(model.encryptedId).pipe(
          map((user) => {
            return RecoveryActions.GetUserByRecoveryEncryptedIdSuccess({ user });
          }),
          catchError((err) => {
            return of(RecoveryActions.GetUserByRecoveryEncryptedIdFailure(err));
          })
        );
      })
    )
  );


  changePassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecoveryActions.ChangePassword),
      mergeMap((model) => {
        return this.authService.updatePassword(model.changeRequest).pipe(
          map((response) => {
            return RecoveryActions.ChangePasswordSuccess({ response });
          }),
          catchError((err) => {
            return of(RecoveryActions.GetUserByRecoveryEncryptedIdFailure(err));
          })
        );
      })
    )
  );

}
